<template>
  <div class="bg-white rounded-lg shadow p-6">
    <div class="space-y-4">
      <!-- Total Plans Card -->
      <div class="bg-gray-50 rounded-lg p-4">
        <h3 class="text-lg font-medium text-gray-900 mb-2">Total des financements</h3>
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-2">
            <span class="text-3xl font-bold text-zebu-orange">
              {{ stats.funded_plans || 0 }}
            </span>
            <span class="text-gray-600">{{ (stats.funded_plans || 0) <= 1 ? 'plan financé' : 'plans financés' }}</span>
          </div>
        </div>
      </div>

      <!-- Loan Types Breakdown -->
      <div v-if="showBreakdown && stats.loanTypeBreakdown?.length" class="space-y-3">
        <h4 class="text-sm font-medium text-gray-700">Détail par type de financement</h4>
        <div class="space-y-2">
          <div v-for="type in stats.loanTypeBreakdown" :key="type.type"
            class="flex items-center justify-between bg-gray-50 p-3 rounded">
            <div>
              <span class="text-sm font-medium text-gray-900">{{ type.type }}</span>
              <p class="text-xs text-gray-500">{{ type.description }}</p>
            </div>
            <span class="text-sm font-semibold text-zebu-orange">{{ type.count }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { memberareaService } from '@/services/memberarea.service'

interface LoanType {
  type: string
  count: number
  description: string
}

interface FundingStats {
  funded_plans: number
  loanTypeBreakdown: LoanType[]
}

const stats = ref<FundingStats>({
  funded_plans: 0,
  loanTypeBreakdown: []
})

const showBreakdown = ref(false)

const fetchStats = async () => {
  try {
    const response = await memberareaService.getDashboardData()
    if (response.success) {
      stats.value = response
    }
  } catch (error) {
    console.error('Erreur lors de la récupération des statistiques:', error)
  }
}

onMounted(() => {
  fetchStats()
})
</script> 